export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 0a1 1 0 011 1v1h6V1a1 1 0 112 0v1h1.5A1.5 1.5 0 0116 3.5V4H0v-.5A1.5 1.5 0 011.5 2H3V1a1 1 0 011-1zM0 6h16v6.5a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 010 12.5V6z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};